import { createContext, useContext } from "react";
import { STRINGS, type UIStrings } from "@/i18n/strings";

// Default to English so any component rendered without a provider (e.g. existing
// component tests) keeps its current strings.
export const LocaleContext = createContext<UIStrings>(STRINGS.en);

export function useStrings(): UIStrings {
  return useContext(LocaleContext);
}
